import { gql } from '@apollo/client';

// Hub 版：hubId 必传；hub manager / 总部用户使用
export const GET_HUB_DAILY_TASK_SUMMARY_AREA_LIST = gql`
  query GetHubDailyTaskSummaryAreaList(
    $taskDate: String!
    $hubId: Long!
    $warehouseIds: [Long!]
    $dspIds: [Long!]
    $areaIds: [Long!]
    $cities: [String!]
    $dimensionType: String
    $pageRequest: DailyTaskPageRequestTypeInput!
  ) {
    getHubDailyTaskSummaryAreaList(
      taskDate: $taskDate
      hubId: $hubId
      warehouseIds: $warehouseIds
      dspIds: $dspIds
      areaIds: $areaIds
      cities: $cities
      dimensionType: $dimensionType
      pageRequest: $pageRequest
    ) {
      calculatedAt
      summaryData {
        deliveryProgress {
          scheduledParcels
          actualPickedUp
          deliveredParcels
          pickupRate
          deliveryRate
        }
        undeliveredDistribution {
          totalUndelivered
          unpicked
          inDelivery
          failedReturned
          failedNotReturned
          warehouseLost
        }
      }
      recordData {
        id
        taskDate
        warehouseId
        warehouseName
        dspId
        dspName
        areaId
        areaName
        allocatedParcels
        pickedUpFromWarehouse
        warehouseLost
        inDelivery
        onTimeDelivery
        overdueDelivery
        deliveredCount
        unclaimedCount
        noAscanDelivery
        transferredIn
        transferredOut
        returned
        damaged
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

// WHS 版：warehouseId 必传；warehouse manager / 总部用户使用
export const GET_WHS_DAILY_TASK_SUMMARY_AREA_LIST = gql`
  query GetWhsDailyTaskSummaryAreaList(
    $taskDate: String!
    $warehouseId: Long!
    $dspIds: [Long!]
    $areaIds: [Long!]
    $cities: [String!]
    $dimensionType: String
    $pageRequest: DailyTaskPageRequestTypeInput!
  ) {
    getWhsDailyTaskSummaryAreaList(
      taskDate: $taskDate
      warehouseId: $warehouseId
      dspIds: $dspIds
      areaIds: $areaIds
      cities: $cities
      dimensionType: $dimensionType
      pageRequest: $pageRequest
    ) {
      calculatedAt
      summaryData {
        deliveryProgress {
          scheduledParcels
          actualPickedUp
          deliveredParcels
          pickupRate
          deliveryRate
        }
        undeliveredDistribution {
          totalUndelivered
          unpicked
          inDelivery
          failedReturned
          failedNotReturned
          warehouseLost
        }
      }
      recordData {
        id
        taskDate
        warehouseId
        warehouseName
        dspId
        dspName
        areaId
        areaName
        allocatedParcels
        pickedUpFromWarehouse
        warehouseLost
        inDelivery
        onTimeDelivery
        overdueDelivery
        deliveredCount
        unclaimedCount
        noAscanDelivery
        transferredIn
        transferredOut
        returned
        damaged
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

// 类型定义
export interface DailyTaskSummaryAreaPageRequestType {
  taskDate: string;
  hubId?: number;
  warehouseId?: string | null;
  warehouseIds?: number[];
  dspIds?: number[];
  areaIds?: number[];
  cities?: string[];
  dimensionType?: string;
  pageRequest: {
    page: number;
    size: number;
    sortBy?: string;
    sortDirection?: 'ASC' | 'DESC';
  };
}

export interface DailyTaskSummaryAreaType {
  id: number;
  taskDate: string;
  warehouseId: string;
  warehouseName?: string | null;
  dspId: number;
  dspName: string | null;
  areaId: number;
  areaName: string | null;
  allocatedParcels: number;
  pickedUpFromWarehouse: number;
  warehouseLost: number;
  inDelivery: number;
  onTimeDelivery: number;
  overdueDelivery: number;
  deliveredCount: number;
  unclaimedCount: number;
  noAscanDelivery: number;
  transferredIn: number;
  transferredOut: number;
  returned: number;
  damaged: number;
}

export interface DailyTaskSummaryAreaPageResponseType {
  content: DailyTaskSummaryAreaType[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

export interface DailyTaskSummaryAreaListData {
  calculatedAt?: string | null;
  summaryData: {
    deliveryProgress: {
      scheduledParcels: number;
      actualPickedUp: number;
      deliveredParcels: number;
      pickupRate: number;
      deliveryRate: number;
    };
    undeliveredDistribution: {
      totalUndelivered: number;
      unpicked: number;
      inDelivery: number;
      failedReturned: number;
      failedNotReturned: number;
      warehouseLost: number;
    };
  };
  recordData: DailyTaskSummaryAreaType[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

export interface GetHubDailyTaskSummaryAreaListResponse {
  getHubDailyTaskSummaryAreaList: DailyTaskSummaryAreaListData;
}

export interface GetWhsDailyTaskSummaryAreaListResponse {
  getWhsDailyTaskSummaryAreaList: DailyTaskSummaryAreaListData;
}
